import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Input, Typography } from "@material-tailwind/react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { loginUser, logout } from "@/redux/slices/userSlices";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { InformationCircleIcon } from "@heroicons/react/24/solid";
import { UserSubmitForm } from "@/utils/interface.global";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const Logout: React.FC = () => {
  const [isPassword, setIsPassword] = useState(true);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  useEffect(() => {
    dispatch(logout());
  }, []);

  return <div className="login-container"></div>;
};

export default Logout;
